<template>
<div class="news">
    <div class="news-top">
        <img class="navBack" @click.stop="back()" src="../../../static/images/shootShop/back.png" alt="" >
        <span>资讯列表</span>
    </div>
    <div class="news-list" v-show="showBox == 1">
        <!-- <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" ref="loadmore" :bottom-all-loaded="allLoaded" :auto-fill="false"> -->
        <mt-loadmore :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" ref="loadmore" :bottom-all-loaded="allLoaded" :auto-fill="false">

            <dl v-for="(item,index) in listArr" @click="goNews(item.id)">
                <dt>
                    <h3>{{item.title}}</h3>
                    <h5>{{item.content}}</h5>
                    <p>{{item.date}}-{{item.time}}</p>
                </dt>
                <dd><img :src="item.url" :onerror="defaultImg"></dd>
            </dl>

            <div class="noDataBottom" v-if="more" style=" margin-bottom: 1.8rem;">没有更多数据了...</div>
        </mt-loadmore>
    </div>
    <div v-show="showBox == 0">
        <div class="null-data-box">
            <img src="../../../static/images/home/null-data.png">
            <p>暂无数据</p>
        </div>
    </div>

</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';

export default {
    name: 'news',
    data () {
        return {
            listArr: [],
            shopId: "",
            typeId: "",
            pageSize: 10, // 每次请求的数量
            pageNum: 1, // 页码 
            brandIndex: 1, 
            allLoaded: false,
            more: false,
            showBox: 1,
            defaultImg: 'this.src="' + require('../../../static/images/lookShop/err.png') + '"',
        }
    },

    computed:{

    },
    updated(){

    },
    methods:{

        // indexFun(index){
        //     if(index == 0){
        //         return true;
        //     }else if(this.listArr[index].create_time != this.listArr[index-1].create_time){
        //         return true;
        //     }else{
        //         return false;
        //     } 
        // },

        // 跳转新闻详情页
        goNews(id){
            this.$router.push({path: '/consult', query:{id: id, backurl: "news"}});
        },

        listData() {
            // alert(pageNum);
            let _this = this;
            let url = _this.changeData() + '/show/getAticleList'
            axios(url,{
                method: 'post',
                params:{
                    pageNum: 1,
                    pageSize: this.pageSize,
                    cityId: 110100
                }
            }).then(data => {
                // console.log(data);
                this.listArr = data.data.articleList;
                // console.log(this.listArr);
                // if(this.listArr.length == 0){
                //     this.showBox = 0;
                // }else{
                //     this.showBox = 1;
                // }

            }).catch(err => {
                console.log(err)
            });
        },

        //下拉刷新
        // loadTop(){

        //     this.listData();
  
        // },

        //上拉加载
        loadBottom() {
            // var _this = this;
            this.brandIndex++;

            let _this = this;
            let url = _this.changeData() + '/show/getAticleList'
            axios(url,{
                method: 'post',
                params:{
                    cityId: 110100,
                    pageSize: this.pageSize, // 每页展示数量
                    pageNum: this.brandIndex, // string  是   当前页
                    // type: this.typeId //0访客列表 1智能推荐
                }
            }).then(data => {

                // console.log(data);

                _this.listArr = _this.listArr.concat(data.data.articleList);

                // console.log(_this.listArr);                

                if(data.data.articleList == ''){
                    _this.allLoaded = true;
                }

                _this.$refs.loadmore.onBottomLoaded();

            }).catch(err => {
                console.log(err)
            });
        },

        handleBottomChange(){
            var that = this;
            if(this.allLoaded == true){
                this.more = true;
                setTimeout(function () {
                    that.more = false;
                },2000)
            }
        },

        back(){
            this.$router.push({path:"/home"});
        }
  
    },
    mounted() {

        this.shopId = this.$route.query.shopid;
        this.typeId = this.$route.query.type;

        this.listData();

        // console.log(this.shopId);
 
    },
    created() { 

       
    }
}
</script>


<style scoped lang="scss">
.news{
    width: 7.5rem;
    background: #fff;
}
.news-top{
    width: 7.5rem;
    height: 1.1rem; 
    border-bottom: 1px solid #f2f2f2;
    text-align: center;
    font-size: .36rem;
    font-weight: 400;
    color: #0f1923;
    line-height: 1.1rem;
    position: fixed;
    left: auto;
    top: 0;
    background: #fff;
    z-index: 9;
    .navBack{
        width: .2rem;
        height: .33rem;
        position: absolute;
        left: .4rem;
        top: .38rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
}
.news-list{
    width: 6.7rem;
    padding-top: 1.1rem;
    margin: 0 auto;
    background: #fff;
    dl{
        width: 6.7rem;
        height: 2rem;
        padding: .4rem 0;
        position: relative;
        border-bottom: 1px solid #f7f7f7;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        dt{
            width: 4.16rem;
            float: left;
            h3{
                font-size: .32rem;
                font-weight: 500;
                color: #0f1923;
                line-height: .42rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                text-align: justify;
            }
            h5{
                font-size: .24rem;
                font-weight: 300;
                color: #333;
                line-height: .34rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                margin: .2rem 0 .16rem;
                text-align: justify;
            }
            p{
                font-size: .24rem;
                font-weight: 300;
                color: #eee;
                line-height: .34rem;
                overflow: hidden;
            }
        }
        dd{
            width: 2.12rem;
            height: 1.6rem;
            float: right;
            img{
                width: 2.12rem;
                height: 1.6rem;
                border-radius: 4px;
            }
        }
    }
}


.noDataBottom{
    text-align: center;
    font-size: .3rem;
    line-height: 1rem;
}

/*无数据*/
.null-data-box{
    text-align: center;
    padding-top: 3rem;
    img{
        width: 1.6rem;
        height: 1.6rem;
    }
    p{
        font-size: .28rem;
        font-weight: 400;
        color: #999;
        line-height: .4rem;
        margin-top: .24rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/home/news.vue